import apiClient from './client';

export const sendgridApi = {
  // ── Single Sends ──

  listSingleSends: async (params = {}) => {
    const response = await apiClient.get('/api/sendgrid/single-sends', { params });
    return response.data;
  },

  getSingleSend: async (id) => {
    const response = await apiClient.get(`/api/sendgrid/single-sends/${id}`);
    return response.data;
  },

  getSingleSendStats: async (id) => {
    const response = await apiClient.get(`/api/sendgrid/single-sends/${id}/stats`);
    return response.data;
  },

  getSingleSendLinkStats: async (id) => {
    const response = await apiClient.get(`/api/sendgrid/single-sends/${id}/links`);
    return response.data;
  },

  getSingleSendPreview: async (id) => {
    const response = await apiClient.get(`/api/sendgrid/single-sends/${id}/preview`, {
      responseType: 'text',
      headers: { 'Accept': 'text/html' },
    });
    return response.data;
  },

  updateSingleSend: async (id, updates) => {
    const response = await apiClient.patch(`/api/sendgrid/single-sends/${id}`, updates);
    return response.data;
  },

  // ── Contacts ──

  getFieldDefinitions: async () => {
    const response = await apiClient.get('/api/sendgrid/field-definitions');
    return response.data;
  },

  searchContacts: async ({ email, sortBy, sortDir } = {}) => {
    const body = {};
    if (email) body.email = email;
    if (sortBy) body.sortBy = sortBy;
    if (sortDir) body.sortDir = sortDir;
    const response = await apiClient.post('/api/sendgrid/contacts/search', body);
    return response.data;
  },

  getContact: async (id) => {
    const response = await apiClient.get(`/api/sendgrid/contacts/${id}`);
    return response.data;
  },

  updateContact: async (id, updates) => {
    const response = await apiClient.put(`/api/sendgrid/contacts/${id}`, updates);
    return response.data;
  },

  getSuppression: async (email) => {
    const response = await apiClient.get(`/api/sendgrid/contacts/${encodeURIComponent(email)}/suppression`);
    return response.data;
  },

  getEngagement: async (email) => {
    const response = await apiClient.get(`/api/sendgrid/contacts/${encodeURIComponent(email)}/engagement`);
    return response.data;
  },

  // ── Local Contacts ──

  listLocalContacts: async ({ limit, cursor, status, sort } = {}) => {
    const params = {};
    if (limit) params.limit = limit;
    if (cursor) params.cursor = cursor;
    if (status) params.status = status;
    if (sort) params.sort = sort;
    const response = await apiClient.get('/api/sendgrid/contacts/local', { params });
    return response.data;
  },

  searchLocalContacts: async (q, { limit } = {}) => {
    const params = { q };
    if (limit) params.limit = limit;
    const response = await apiClient.get('/api/sendgrid/contacts/local/search', { params });
    return response.data;
  },

  getLocalContact: async (email) => {
    const response = await apiClient.get(`/api/sendgrid/contacts/local/${encodeURIComponent(email)}`);
    return response.data;
  },

  getLocalContactEvents: async (email, { limit, cursor } = {}) => {
    const params = {};
    if (limit) params.limit = limit;
    if (cursor) params.cursor = cursor;
    const response = await apiClient.get(`/api/sendgrid/contacts/local/${encodeURIComponent(email)}/events`, { params });
    return response.data;
  },

  // ── Events ──

  listEventsByDate: async (date, { limit, cursor } = {}) => {
    const params = { date };
    if (limit) params.limit = limit;
    if (cursor) params.cursor = cursor;
    const response = await apiClient.get('/api/sendgrid/events/by-date', { params });
    return response.data;
  },

  listEventsByType: async (date, type, { limit, cursor } = {}) => {
    const params = { date, type };
    if (limit) params.limit = limit;
    if (cursor) params.cursor = cursor;
    const response = await apiClient.get('/api/sendgrid/events/by-type', { params });
    return response.data;
  },

  getEventsByMessageId: async (messageId) => {
    const response = await apiClient.get(`/api/sendgrid/events/by-message/${encodeURIComponent(messageId)}`);
    return response.data;
  },

  // ── Contact Stats ──

  listContactStats: async ({ limit, cursor, startDate, endDate } = {}) => {
    const params = {};
    if (limit) params.limit = limit;
    if (cursor) params.cursor = cursor;
    if (startDate) params.startDate = startDate;
    if (endDate) params.endDate = endDate;
    const response = await apiClient.get('/api/sendgrid/contacts/stats', { params });
    return response.data;
  },

  computeContactStats: async (date) => {
    const response = await apiClient.post('/api/sendgrid/contacts/stats/compute', { date });
    return response.data;
  },

  // ── Sync ──

  startInitialSync: async (listIds) => {
    const body = {};
    if (listIds) body.listIds = listIds;
    const response = await apiClient.post('/api/sendgrid/sync/initial', body);
    return response.data;
  },

  checkExportStatus: async (jobId) => {
    const response = await apiClient.get(`/api/sendgrid/sync/initial/${jobId}`);
    return response.data;
  },

  importExportedContacts: async (jobId, { sourceListIds } = {}) => {
    const body = sourceListIds?.length ? { sourceListIds } : {};
    const response = await apiClient.post(`/api/sendgrid/sync/initial/${jobId}/import`, body);
    return response.data;
  },

  runQuickSync: async (since) => {
    const body = {};
    if (since) body.since = since;
    const response = await apiClient.post('/api/sendgrid/sync/quick', body);
    return response.data;
  },

  syncSuppressions: async (emails) => {
    const body = {};
    if (emails) body.emails = emails;
    const response = await apiClient.post('/api/sendgrid/sync/suppressions', body);
    return response.data;
  },
};
